import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import * as d3 from "d3";
import { FeatureDataStateService } from "../core-module/services/state/feature-data-state.service";
import { MtpExtrasStateService } from "../core-module/services/state/mtp-extras-state.service";
import { drawDynaLineAndPath as _drawDynaLineAndPath } from "../shared-module/graph-utils/dyna-graph-common";
@Component({
  standalone: false,
  selector: "app-mtp-graph",
  templateUrl: "./mtp-graph.component.html",
  styleUrls: ["./mtp-graph.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MtpGraphComponent implements OnInit {
  @Input() readOnly: boolean = true;

  inputXRange = [0, 165];

  inputYRange = [0, 100];

  data: LegacyAny[] = [
    { dyanXTime: 0, dyanYOutput: 100 },
    { dyanXTime: 80, dyanYOutput: 100 },
    { dyanXTime: 90, dyanYOutput: 10 },
    { dyanXTime: 165, dyanYOutput: 10 },
  ];
  data1: LegacyAny[] = [];
  dataFromTableValues: LegacyAny[] = [];

  focus;
  drag;
  public margin = { top: 50, right: 50, bottom: 50, left: 50 };
  public width: number;
  public height: number;
  public x: LegacyAny;
  public y: LegacyAny;
  public svg6: LegacyAny;
  public line: d3.Line<[number, number]>; // this is line defination
  public area: d3.area<[number, number]>; // this is area defination
  public id = "lineChart";
  public color2 = "#00b36b";
  newData: LegacyAny;
  changedPoint: LegacyAny;
  feedMaxValue: LegacyAny = 112;
  NormalLevelMaximum: LegacyAny;
  BackgroundLevelMaximum: LegacyAny;
  Maxdata: LegacyAny = [];
  Tmaxstart: LegacyAny;
  TmaxEnd: LegacyAny;
  TmaxShutDown: LegacyAny;
  scrolPoint: LegacyAny;
  deRatingdyanYOutput: LegacyAny;
  LamOffValue: LegacyAny;
  DtlDimStopValue: LegacyAny;
  TmaxdeRatingDim: LegacyAny;
  Forbidenarea: d3.area<[number, number]>; // this is area defination
  deratingLabelYaxis: number;
  TminEnd: LegacyAny;
  MaxLimit: LegacyAny;
  TmindeRatingDim: LegacyAny;
  graphEnabled: boolean;
  philipsLEDChecked: boolean;
  tcDeltaValue: number;
  mtpStartMax: number;
  mtpStopMax: number;
  mtpDeratingMax: number;
  mtpDimStartMaxSch: number;
  mtpDimStopMaxSch: number;
  mtpDimLevelMaxSch: number;

  constructor(
    private mtpExtras: MtpExtrasStateService,
    private featureData: FeatureDataStateService
  ) {}

  ngOnInit() {
    // this.dynaDimmer.getDynaTimeReferencedMode.subscribe(response => {

    //   if(response===true)
    //   {
    //     this.dynaDimmer.getFinalDynaDimmerData.subscribe(response=>{
    //       this.addDynaDetails(response);

    //     });
    //   }
    // })

    this.mtpExtras.getTCDeltaValueMTP.subscribe((delta) => {
      this.tcDeltaValue = delta;
    });
    this.mtpExtras.getMtpDimStartMax.subscribe((value) => {
      this.mtpDimStartMaxSch = value;
    });
    this.mtpExtras.getMtpDimStopMax.subscribe((value) => {
      this.mtpDimStopMaxSch = value;
    });
    this.mtpExtras.getMtpDimLevelMax.subscribe((value) => {
      this.mtpDimLevelMaxSch = value;
    });
    this.featureData.getMtpData.subscribe((response) => {
      this.data = this.addMTPData(response);

      this.buildSvg();
      this.addXandYAxis();
      this.drawLineAndPath();
      this.addDrag();
    });

    this.newData = this.data1;

    this.buildSvg();
    this.addXandYAxis();
    this.drawLineAndPath();
    this.addDrag();
  }
  addMTPData(response: LegacyAny): LegacyAny[] {
    //let dataFromTable = JSON.parse(response);
    // console.log(response);

    this.mtpStartMax = response.DimStartValueMax
      ? response.DimStartValueMax
      : this.mtpDimStartMaxSch;
    this.mtpStopMax = response.DimStopValueMax
      ? response.DimStopValueMax
      : this.mtpDimStopMaxSch;
    this.mtpDeratingMax = response.DimLevelValueMax
      ? response.DimLevelValueMax
      : this.mtpDimLevelMaxSch;
    if (response.SelectedNtc === "PhilipsLedLightEngines") {
      this.philipsLEDChecked = true;
    } else {
      this.philipsLEDChecked = false; //MOWEB 1.1
    }
    if (response.Enabled === true) {
      this.graphEnabled = true;
    }
    const dimStartValue =
      response.DimStartValue > response.DimStartValueMax
        ? response.DimStartValueMax
        : response.DimStartValue;
    const dimStopValue =
      response.DimStopValue > response.DimStopValueMax
        ? response.DimStopValueMax
        : response.DimStopValue;
    const dimLevel =
      response.DimLevelValue > response.DimLevelValueMax
        ? response.DimLevelValueMax
        : response.DimLevelValue;
    return [
      { dyanXTime: 0, dyanYOutput: this.mtpDimLevelMaxSch },
      { dyanXTime: dimStartValue, dyanYOutput: this.mtpDimLevelMaxSch },
      { dyanXTime: dimStopValue, dyanYOutput: dimLevel },
      { dyanXTime: this.mtpDimStopMaxSch, dyanYOutput: dimLevel },
    ];
  }

  public buildSvg() {
    this.svg6 = d3.select("#svg6");
    this.width = 960 - this.margin.left - this.margin.right;
    this.height = 500 - this.margin.top - this.margin.bottom;
  }
  public addXandYAxis() {
    // range of data configuring
    this.x = d3.scaleLinear().range([0, this.width]);
    this.y = d3.scaleLinear().range([this.height, 0]);
    this.x.domain(this.inputXRange);
    this.y.domain(this.inputYRange);
  }

  public drawLineAndPath() {
    // Delegated to shared dyna-graph-common.drawDynaLineAndPath.
    // mtp-graph-specific: #svg6 host, gradient6, x-label "Temperature (&degC)"
    // at x(90), y-label "Dim level (%)" anchored at -height/1.4 + 35,
    // 4px circles.
    _drawDynaLineAndPath.call(this, {
      hostSvg: this.svg6,
      gradientId: "gradient6",
      xLabelAnchor: 90,
      clampY: false,
      svgSelector: "#svg6",
      xAxisLabel: "Temperature (&degC)",
      yAxisLabel: "Dim level (%)",
      circleRadius: 4.0,
      yLabelX: 0 - this.height / 1.4 + 35,
    });
  }

  // gridlines in x axis function
  make_x_gridlines() {
    return d3
      .axisBottom(this.x)
      .ticks(17)
      .tickFormat(
        (d, i) =>
          [
            0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150,
            160, 165,
          ][i]
      );

    //tickFormat(x=>`(${x.toFixed(1)})`);
  }
  // gridlines in y axis function
  make_y_gridlines() {
    return d3.axisLeft(this.y).ticks(10);
  }

  public addDrag() {
    if (this.readOnly) {
      return;
    }
    const _this = this;
    const selection = this.focus.selectAll("circle").call(
      d3
        .drag()
        .on("start", function (event, d) {
          const control = _this.dragged();
          /*  d["dyanXTime"] = control.x.invert(event.x);
          d["dyanYOutput"] = control.y.invert(event.y);
          const n = selection.nodes();
          const i = n.indexOf(this);
          const m = d3.select(n[i]).node();
          d3.select(m)
            .raise()
            .attr("cx", control.x(d.dyanXTime))
            .attr("cy", control.y(d.dyanYOutput));
          control.focus.select("path").attr("d", control.line); */
        })
        .on("drag", function (event, d) {
          const control = _this.dragged();
          const n = selection.nodes();
          const i = n.indexOf(this);
          if (i >= 0 && i <= 3) {
            control.changedPoint = i;
            const m = d3.select(n[i]).node();

            if (control.changedPoint == 0 && control.graphEnabled) {
              d.dyanXTime = 0;
              d.dyanYOutput = _this.mtpDeratingMax;
            }

            if (
              control.changedPoint == 1 &&
              control.graphEnabled &&
              !_this.philipsLEDChecked
            ) {
              d.dyanXTime = control.x.invert(event.x);
              if (d.dyanXTime < 0) {
                return;
              }
              if (d.dyanXTime > _this.mtpStopMax - _this.tcDeltaValue)
                d.dyanXTime = _this.mtpStopMax - _this.tcDeltaValue;
              d.dyanYOutput = _this.mtpDeratingMax;

              const stopLevelPrev = control.data[2].dyanXTime;
              if (d.dyanXTime > stopLevelPrev - _this.tcDeltaValue) {
                d.dyanXTime = stopLevelPrev - _this.tcDeltaValue;
              }
            } else if (control.changedPoint == 1) {
              const maxXCheck = control.x.invert(event.x);
              const maxYCheck = control.y.invert(event.y);
              if (!_this.philipsLEDChecked) {
                if (maxXCheck > _this.mtpStartMax) {
                  d.dyanXTime = _this.mtpStartMax;
                }
                if (maxYCheck > _this.mtpDeratingMax) {
                  d.dyanYTime = _this.mtpDeratingMax;
                }
              }
            }
            if (
              control.changedPoint == 2 &&
              control.graphEnabled &&
              !_this.philipsLEDChecked
            ) {
              d.dyanXTime = control.x.invert(event.x);
              d.dyanYOutput = control.y.invert(event.y);
              if (d.dyanXTime > _this.mtpStopMax)
                d.dyanXTime = _this.mtpStopMax;
              if (d.dyanYOutput > _this.mtpDeratingMax)
                d.dyanYOutput = _this.mtpDeratingMax;
              if (d.dyanYOutput <= 1) d.dyanYOutput = 1;
              const startLevelPrev = control.data[1].dyanXTime;
              if (d.dyanXTime < startLevelPrev)
                d.dyanXTime = startLevelPrev + _this.tcDeltaValue;

              const drag3Pt = d3.select(n[3]).node();
              d3.select(drag3Pt)
                .attr("cx", control.x(_this.mtpStopMax))
                .attr("cy", control.y(d.dyanYOutput));
              control.focus.select("path").attr("d", control.area);
              control.focus.select("path").attr("d", control.line);

              control.data[3].dyanYOutput = d.dyanYOutput;
            } else if (control.changedPoint == 2 && !_this.philipsLEDChecked) {
              d.dyanXTime = 90;
              //d.dyanYOutput = 100;
            }
            if (
              control.changedPoint == 3 &&
              (control.graphEnabled || control.philipsLEDChecked)
            ) {
              d.dyanXTime = _this.mtpStopMax;
              d.dyanYOutput = control.y.invert(event.y);
              if (d.dyanYOutput > _this.mtpDeratingMax)
                d.dyanYOutput = _this.mtpDeratingMax;
              if (d.dyanYOutput <= 1) d.dyanYOutput = 1;

              const drag2Pt = d3.select(n[2]).node();
              d3.select(drag2Pt)
                .attr("cx", control.x(control.data[2].dyanXTime))
                .attr("cy", control.y(d.dyanYOutput));
              control.focus.select("path").attr("d", control.area);
              control.focus.select("path").attr("d", control.line);
              control.data[2].dyanYOutput = d.dyanYOutput;
            }
            d3.select(m)
              .raise()
              .attr("cx", control.x(d.dyanXTime))
              .attr("cy", control.y(d.dyanYOutput));
            control.focus.select("path").attr("d", control.area);
          }
        })
        .on("end", this.dragended.bind(this))
    );
  }

  dragstarted(d) {}

  public dragged() {
    return this;
  }
  public dragended(d) {
    //console.log("AFter Drag");
    this.featureData.sendMtpGraphdata(this.data);
  }
}

